import { useQuery, keepPreviousData } from "@tanstack/vue-query";
import { useConsultationsApi } from "./use-consultations";

export function useGetSpecialtyModels() {
  const { getSpecialtyModels } = useConsultationsApi();

  return useQuery({
    queryKey: ["specialties"],
    queryFn: () => getSpecialtyModels(),
    placeholderData: keepPreviousData,
  });
}

export function useGetConsultation({ consultationId }) {
  const { getConsultation } = useConsultationsApi();

  return useQuery({
    queryKey: ["consultation", consultationId],
    queryFn: () => getConsultation({ consultationId: consultationId.value }),
    placeholderData: keepPreviousData,
    // Atualiza a consulta enquanto houver exames em processamento (pending)
    refetchInterval: (query) => {
      const data = query.state?.data;
      if (!data?.exams?.length) return false;
      const hasPending = data.exams.some((e) => e.status === 'pending');
      return hasPending ? 5000 : false;
    },
  });
}

export function useGetConsultations({ page, limit, search, status, period }) {
  limit = limit || 7;

  const { getConsultations } = useConsultationsApi();

  return useQuery({
    queryKey: ["consultations", page, limit, search, status, period],
    queryFn: () => getConsultations({
      page: page.value,
      limit,
      search: search?.value,
      status: status?.value,
      period: period?.value
    }),
    placeholderData: keepPreviousData,
  });
}

export function useGetConsultationReport({ consultationId, reportId }) {
  const { getConsultationReport } = useConsultationsApi();
  return useQuery({
    queryKey: ["consultationReport", consultationId, reportId],
    queryFn: () =>
      getConsultationReport({
        consultationId: consultationId.value,
        reportId: reportId.value,
      }),
  });
}
